import { observer } from 'mobx-react';
import { FC } from 'react';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  title: string;
  selectedOptions: IPickerOption[];
  options: IPickerOption[];
  onSelectOptions: (options: IPickerOption[]) => void;
  required?: boolean;
}

const NotificationsScreensPicker: FC<IProps> = observer((props: IProps): JSX.Element => {
  return (
    <div className="d-flex flex-column gap-10">
      <Text type={TEXT.BLOCK_HEADER} text={props.title} required={props.required} />

      <Picker
        selectedOptions={props.selectedOptions}
        options={props.options}
        onSelect={props.onSelectOptions}
        noReset
        className="notifications-screens-picker"
      />
    </div>
  );
});

export default NotificationsScreensPicker;
